import { render, staticRenderFns } from "./newLy.vue?vue&type=template&id=a6990bf6&scoped=true&"
import script from "./newLy.vue?vue&type=script&lang=js&"
export * from "./newLy.vue?vue&type=script&lang=js&"
import style0 from "./newLy.vue?vue&type=style&index=0&id=a6990bf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6990bf6",
  null
  
)

export default component.exports